import {css} from "lit";

export default css`
  .paypalLogo{
    width: 5rem;
    height: 1.5rem;
    background-image: url(/uxt/static/external/misc/logo-paypal.svg);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: bottom;
  }

  .venmoLogoBG {
        background-color: #008CFF;
        padding: 16px
    }

  .venmoLogo{
    width: 3rem;
    height: 1.5rem;
    background-image: url(/uxt/static/external/misc/logo-venmo.svg);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: bottom;
  }

  .applePayLogo {
    width: 3rem;
    height: 1.5rem;
    background-image: url(/uxt/static/external/misc/logo-apple-pay.svg);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: bottom;
  }
  
  .googlePayLogo {
    width: 3rem;
    height: 1.5rem;
    background-image: url(/uxt/static/external/misc/logo-google-pay.svg);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: bottom;
  }

  .venmoButtonLogo {
        position: relative;
        display: inline-block;
       
    }
    .venmoButtonLogo .active {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
    }
    .venmoButtonLogo:hover .active {
        display: inline;
    }

  .idealBtn button {
    padding: 8px 10px !important;
    background: #992D4E !important;
    border-radius: 4.8px !important;
  }

  .idealBtn img {
    width: 7.6rem;
    height: 2.8rem;
  }
`;